var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPowerbiDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 24,
  viewBox: "0 0 18 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_103_13)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 1.00125V22.9987C18 23.5516 17.5516 24 16.9987 24H10.7512C10.1983 24 9.75 23.5516 9.75 22.9987V1.00125C9.75 0.448275 10.1983 0 10.7512 0H16.9987C17.5518 0 18 0.448273 18 1.00125Z",
  fill: "#CAC9C9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.125 7V24H4.875V7C4.875 6.44772 5.32272 6 5.875 6H12.125C12.6773 6 13.125 6.44772 13.125 7Z",
  fill: "#E9E7E7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 13V22.9999C0 23.5522 0.44772 24 1 24H8.25V13C8.25 12.4477 7.80228 12 7.24999 12H1C0.44772 12 0 12.4477 0 13Z",
  fill: "#FBFBFB"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_103_13"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 24,
  fill: "white"
})))));
export { SvgPowerbiDark as ReactComponent };
export default __webpack_public_path__ + "static/media/powerbiDark.129bb672.svg";